module.exports = __webpack_public_path__ + "static/img/满意度调查-EN.3b65c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/满意度调查-EN.jpg
// module id = yYxg
// module chunks = 17